import React, { useState, useEffect, useRef } from "react";
import queryString from "query-string";
import { CSSTransition } from "react-transition-group";
import { Form, Progress, Alert } from "reactstrap";

import { useLocalization } from "../../containers/I18nProvider";
import { WithCaptcha } from '../../containers/captcha';
import logo from "./img/logo.png"

const LoginForm = ({ api, location, TurnstileComponent, ...props }) => {
  const nodeRef = useRef(null);
  const { translate, changeDefaultLocale } = useLocalization();
  changeDefaultLocale('es');
  const [onLogin, setOnLogin] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [error, setError] = useState({
    open: false,
    message: "",
  });
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const parameters = queryString.parse(location.search);

  useEffect(() => {
    setShowForm(true)
  }, []);

  const onSubmit = async (ev) => {
    ev.preventDefault();
    setOnLogin(true)
    setError({
      open: false,
      message: "",
    })

    const encodedPassword = encodeURIComponent(password);
    api.userPassLogin(
      {
        username,
        password: encodedPassword,
      },
      parameters
    )
      .then((response) => {
        setOnLogin(false)
        window.location = parameters.redirect_uri + "?" + queryString.stringify(response);
      })
      .catch((error) => {
        const _translate = translate(error.errorCode);
        let message = translate("RequestLoginErrorMessage")
        if (_translate) {
          message = _translate;
        } else if (error.details) {
          message = error.details;
        }
        setOnLogin(false)
        setError({ open: true, message })
      });
  }

  return (
    <CSSTransition
      in={showForm}
      timeout={300}
      classNames="formshow"
      nodeRef={nodeRef}
      unmountOnExit
    >
      <div className="login-startv-container text-align-center" ref={nodeRef}>
        <div className='logo-startv-container'>
          <img src={logo} alt="logo" className="logo-startv rounded mx-auto d-block" />
        </div>
        <div className="login-startv-body">
          <Form onSubmit={onSubmit}>
            <input
              className="user-input-startv"
              disabled={onLogin}
              onChange={e => setUsername(e.target.value)}
              required={true}
              tabIndex={1}
              type="text"
              autoCorrect="off"
              autoCapitalize="none"
              name="username"
              placeholder={translate("PlaceholderUserName")}
            />
            <input
              className="user-input-startv"
              required={true}
              disabled={onLogin}
              onChange={e => setPassword(e.target.value)}
              tabIndex={1}
              type="password"
              autoCorrect="off"
              autoCapitalize="none"
              name="password"
              placeholder={translate("PlaceholderPassword")}
            />
            <div>
              {!onLogin ?
                <button
                  block={!parameters.failureRedirect}
                  tabIndex={1}
                  className="enter-startv btn-lg btn-block"
                  type="submit"
                  name="submit"
                  disabled={!props.turnstileSuccess}
                >
                  {translate("ingresar")}
                </button> :
                <Progress animated color="danger" value={100} />}
            </div>
            <div className="messages-container">
              <Alert color="danger" id="error-message" isOpen={error.open} toggle={() => setError({ ...error, open: false })}>
                {error.message}
              </Alert>
            </div>
            <div>
              <p className="text-center startv-link">{translate("ForgotPassword")}
                <a href="https://estadodecuentaenlinea.stargroup.com.mx:5000/#/registrotbx" target="_blank" rel="noopener noreferrer"> Regístrate aquí</a></p>
              <p className="text-center startv-link">
                <a href="https://estadodecuentaenlinea.stargroup.com.mx:5000/#/recuperartbx" target="_blank" rel="noopener noreferrer">¿Olvidaste tu contraseña?</a></p>
            </div>
            <TurnstileComponent setTurnstileSuccess={props.setTurnstileSuccess} />
          </Form>
        </div>
      </div>
    </CSSTransition>
  );
};

export default WithCaptcha(LoginForm, { useInsideForm: true, style: { marginTop: '2rem' } });
